import { BillingPeriod } from '@atlaz/billing/constants/billing-subscription';
import { BillingPlan } from '@atlaz/billing/interfaces/billing-plan';

export const calcTotalPrice = (count: number, plan: BillingPlan, period: BillingPeriod) =>
  count * plan.price[period] * (period === BillingPeriod.Year ? 12 : 1);
